import { createContext, ReactElement, useContext, useMemo } from "react"

import CoreDeviceDetails from "../../../ttr/formPages/coreDeviceDetails/coreDeviceDetails"
import { TTRDeviceFormData } from "../../../ttr/types/providerTypes"
import { IDeviceFormContextValue } from "../../../types/providerTypes"
import { CreateV2GBundleContext } from "../providers/baseProviders/createV2GBundleProvider"

const BundleTTRContext = createContext(
    {} as IDeviceFormContextValue<TTRDeviceFormData>
)

const CoreV2GGenerationDetails = (): ReactElement => {
    const {
        currentIndex,
        setCurrentIndex,
        canEditManufacturer,
        ttrFormData,
        setTtrFormData,
        generatedTtrDeviceId,
        generatedTtrDeviceRef,
        formIsLoading,
        errors,
        inverterCategoryId,
        v2gDeviceTypeId,
    } = useContext(CreateV2GBundleContext)

    const contextValue = useMemo(
        () => ({
            currentIndex,
            setCurrentIndex,
            canEditManufacturer,
            formData: ttrFormData,
            setFormData: setTtrFormData,
            deviceId: generatedTtrDeviceId,
            deviceRef: generatedTtrDeviceRef,
            onSubmit: async () => undefined,
            submitLoading: false,
            submitSuccessful: false,
            saveDraft: async () => undefined,
            saveDraftLoading: false,
            saveDraftSuccessful: false,
            formIsLoading,
            errors,
        }),
        [
            currentIndex,
            setCurrentIndex,
            canEditManufacturer,
            ttrFormData,
            setTtrFormData,
            generatedTtrDeviceId,
            generatedTtrDeviceRef,
            formIsLoading,
            errors,
        ]
    )

    return (
        <BundleTTRContext.Provider value={contextValue}>
            <CoreDeviceDetails
                context={BundleTTRContext}
                hideDraftAction
                lockedCategoryId={inverterCategoryId}
                lockedTypeId={v2gDeviceTypeId}
                helperAlert="For this V2G bundle flow, Device Category and Device Type are set automatically so the inverter is created with the correct V2G settings."
            />
        </BundleTTRContext.Provider>
    )
}

export default CoreV2GGenerationDetails
